module.exports = __webpack_public_path__ + "img/icon-radio-de-survey.b0c4e7e5.svg";